import api from '@/apis/di/taskAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';

// Combo grid Khoản
export const useTaskComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();
  // func call api lấy dữ liệu combo
  const onTaskComboboxLoadData = (payload, row, column, custom) => {
    payload.sort = 'task_code';
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let ors1 = [{ Field: 'is_parent', Operator: 'NULL' }];
    let extend = [
      { Field: 'inactive', Value: false, Ors: ors },
      { Field: 'is_parent', Value: false, Ors: ors1 },
    ];
    payload.filter = extendFilter(payload.filter, extend);
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField, custom?.callBackFn);
  };

  const onTaskComboboxLoadDataAllActive = (payload, row, column, custom) => {
    payload.sort = 'task_code';
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let extend = [{ Field: 'inactive', Value: false, Ors: ors }];
    payload.filter = extendFilter(payload.filter, extend);
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField, custom?.callBackFn);
  };

  // config columns combo
  const TaskComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã nhiệm vụ',
        dataField: 'task_code',
        width: 120,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên nhiệm vụ',
        dataField: 'task_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 480,
      },
    ],
    displayField: 'task_code',
    valueField: 'task_id',
    queryMode: 'remote',
    dropdownWidth: 600,
    quickSearch: 'TaskQuickSearch',
    quickSearchParam: {
      isFilter: true,
      filterFunc: x => !x.inactive && !x.is_parent,
    },
    comboboxLoadData: onTaskComboboxLoadData,
  };

  // Sự kiện load combo trên grid
  return {
    TaskComboConfig,
    onTaskComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
    onTaskComboboxLoadDataAllActive,
  };
};
